export const FETCH_RANKING = 'FETCH_RANKING';
